export default __webpack_public_path__ + "static/media/12.ab7b84ea.mp3";